<template>
    <div>
        <el-form ref="userForm" label-position="right" label-width="100px" :model="user" style="width: 400px;">
            <el-form-item label="Email">
                <el-input v-model="user.attributes.email"></el-input>
            </el-form-item>
            <el-form-item label="Name">
                <el-input v-model="user.attributes.name"></el-input>
            </el-form-item>
            <div style="display: flex; justify-content: space-between; margin-left: 100px;">
                <el-button v-if="$route.params.userId != 'new'" type="danger" @click="deleteItem">Delete</el-button>
                <el-button type="primary" @click="submitForm('userForm')">{{getSubmitTitle()}}</el-button>
            </div>
        </el-form>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    data() {
        return {
            user: { attributes: {} }
        }
    },
    mounted() {
        if (this.$route.params.userId == 'new') {
            this.user = {
                attributes: {

                }
            }
        } else {
            let user = this.$store.getters['users/byId']({ id: this.$route.params.userId });
            if (user) {
                this.user = user;
            } else {
                this.$store.dispatch('users/loadById', { id: this.$route.params.userId }).then(() => {
                    this.user = this.$store.getters['users/byId']({ id: this.$route.params.userId });
                });
            }
        }
    },
    methods: {
        getSubmitTitle() {
            return this.$route.params.userId == 'new' ? 'Create' : 'Update';
        },
        submitForm(formName) {
            if (this.$route.params.userId == 'new') {
                this.$store.dispatch('users/create', this.user);
            } else {
                this.$store.dispatch('users/update', this.user);
            }
        },
        deleteItem() {
            this.user.attributes.is_deleted = true;
            this.$store.dispatch('users/update', this.user)
                .then(() => {
                    this.$notify({
                        title: 'Deleted',
                        type: 'success'
                    });
                })
                .catch(error => {
                    this.$notify({
                        title: 'Failed',
                        message: 'Failed to delete',
                        type: 'error'
                    });
                })
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        }
    }
}
</script>